import { FileValidationError } from './file-validation.error';

export const ALLOWED_FILE_EXTENSIONS = [
  'pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'xls', 'xlsx', 'xlsm',
  'txt', 'rtf', 'odt', 'csv', 'heic', 'heif', 'webp', 'jfif',
  'tif', 'tiff', 'bmp', 'eml', 'msg', 'zip', 'ods'
];
export const ALLOWED_FILE_EXTENSIONS_ACCEPT = ALLOWED_FILE_EXTENSIONS.map(ext => '.' + ext).join(',');

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
const RESERVED_WINDOWS_FILENAMES = [
  'con',
  'prn',
  'aux',
  'nul',
  'com1',
  'com2',
  'com3',
  'com4',
  'com5',
  'com6',
  'com7',
  'com8',
  'com9',
  'lpt1',
  'lpt2',
  'lpt3',
  'lpt4',
  'lpt5',
  'lpt6',
  'lpt7',
  'lpt8',
  'lpt9'
];

export function validateUploadFile(file: File) {
  validateUploadFileSize(file);
  validateUploadFilename(file.name);
}

export function validateUploadFileSize(file: File) {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new FileValidationError('File size exceeds maximum allowed size of 50MB');
  }
}

export function validateUploadFilename(filename: string) {
  if (!filename) {
    throw new FileValidationError('Filename cannot be null or empty');
  }

  if (filename.includes('..') || filename.includes('/') || filename.includes('\\')) {
    throw new FileValidationError('Filename cannot contain path traversal characters (.., /, \\)');
  }

  if (filename.includes('\0')) {
    throw new FileValidationError('Filename cannot contain null bytes');
  }

  for (let i = 0; i < filename.length; i++) {
    const charCode = filename.charCodeAt(i);
    const isAllowedControlCharacter = charCode === 9 || charCode === 10 || charCode === 13;

    if ((charCode < 32 || charCode === 127) && !isAllowedControlCharacter) {
      throw new FileValidationError('Filename cannot contain control characters');
    }
  }

  const lowerFilename = filename.toLowerCase();
  const isReservedFilename = RESERVED_WINDOWS_FILENAMES.some(
    (reservedFilename) =>
      lowerFilename === reservedFilename ||
      lowerFilename.startsWith(reservedFilename + '.') ||
      lowerFilename.startsWith(reservedFilename + ':')
  );

  if (isReservedFilename) {
    throw new FileValidationError('Filename cannot be a reserved system name');
  }

  if (filename.length > 255) {
    throw new FileValidationError('Filename exceeds maximum length of 255 characters');
  }
}
